import React, { useState } from "react";
import ReportErrorModal from "../../../components/modal/ReportErrorModal";
import { tagIcon } from "../../../constants/icons";
import { FaRegBookmark, FaBookmark } from "react-icons/fa";
import PdfReader from "../../../components/PdfReader";
import { getFileType } from "../../../utils/helper";

const Q_PLACEHOLDER = "https://placehold.co/320x240?text=Question";
const MS_PLACEHOLDER = "https://placehold.co/320x240?text=No+scheme";
const SOLUTION_PLACEHOLDER = "https://placehold.co/320x240?text=No+solution";

function ExamPaperTableRow({
  question,
  isBookmarked,
  handleBookmarkClick,
  handleQuestionClick,
}) {
  const [showReportModal, setShowReportModal] = useState(false);
  const title = `Q. ${question.question_number} ${question.part || ""}`.trim();
  const topic = question.topics?.[0]?.title;

  const onQuestionImgError = (e) => {
    e.target.onerror = null;
    e.target.src = Q_PLACEHOLDER;
  };

  const onMsImgError = (e) => {
    e.target.onerror = null;
    e.target.src = MS_PLACEHOLDER;
  };

  return (
    <>
      <div className="exam-paper-table-row" role="row">
        <div className="exam-paper-table-row-details">
          <div className="exam-paper-table-row-top">
            <span
              role="button"
              tabIndex={0}
              className="exam-paper-table-bookmark"
              onClick={(e) => handleBookmarkClick(e, question, isBookmarked)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleBookmarkClick(e, question, isBookmarked);
                }
              }}
              aria-label={isBookmarked ? "Remove bookmark" : "Add bookmark"}
            >
              {isBookmarked ? <FaBookmark /> : <FaRegBookmark />}
            </span>
            <div className="exam-paper-table-row-text">
              <button
                type="button"
                className="exam-paper-table-title-btn"
                onClick={() => handleQuestionClick(question)}
              >
                {title}
              </button>
              <button
                type="button"
                className="exam-paper-table-report"
                onClick={() => setShowReportModal(true)}
              >
                Report error
              </button>
            </div>
          </div>
          <div className="exam-paper-table-tags">
            {topic ? (
              <span className="exam-paper-table-tag exam-paper-table-tag--topic">
                {tagIcon}
                <span>{topic}</span>
              </span>
            ) : null}
            {question.paper ? (
              <span className="exam-paper-table-tag">{question.paper}</span>
            ) : null}
            {question.year != null && question.year !== "" ? (
              <span className="exam-paper-table-tag">{question.year}</span>
            ) : null}
          </div>
        </div>
        <div className="exam-paper-table-row-previews">
          <div className="exam-paper-table-preview-col">
            <span className="exam-paper-table-preview-label">Question</span>
            <button
              type="button"
              className="exam-paper-table-thumb"
              onClick={() => handleQuestionClick(question)}
              aria-label={`Open question ${question.question_number}`}
            >
              {getFileType(question?.question_file) === "pdf" ? (
                <PdfReader
                  file={question.question_file}
                  showFullScreenButton={false}
                />
              ) : (
                <img
                  src={question?.question_file || Q_PLACEHOLDER}
                  alt=""
                  onError={onQuestionImgError}
                />
              )}
            </button>
          </div>
          <div className="exam-paper-table-preview-col">
            <span className="exam-paper-table-preview-label">
              Marking scheme
            </span>
            <button
              type="button"
              className="exam-paper-table-thumb"
              onClick={() => handleQuestionClick(question)}
              aria-label="Open question with marking scheme"
            >
              {getFileType(question?.ms_file) === "pdf" ? (
                <PdfReader
                  file={question.ms_file}
                  showFullScreenButton={false}
                />
              ) : (
                <img
                  src={question?.ms_file || MS_PLACEHOLDER}
                  alt=""
                  onError={onQuestionImgError}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      <ReportErrorModal
        show={showReportModal}
        handleClose={() => setShowReportModal(false)}
        questionText={title}
        questionId={question._id}
      />
    </>
  );
}

function ExamPaperTableView({
  questions,
  allBookmarkedIds,
  handleBookmarkClick,
  handleQuestionClick,
}) {
  return (
    <div
      className="exam-paper-table"
      role="table"
      aria-label="Past exam questions"
    >
      <div className="exam-paper-table-header" role="row">
        <div className="exam-paper-table-header-cell exam-paper-table-header-cell--details">
          Details
        </div>
        <div className="exam-paper-table-header-previews">
          <div className="exam-paper-table-header-cell">Question</div>
          <div className="exam-paper-table-header-cell">Marking scheme</div>
        </div>
      </div>
      <div className="exam-paper-table-body" role="rowgroup">
        {questions.map((question) => (
          <ExamPaperTableRow
            key={question._id}
            question={question}
            isBookmarked={allBookmarkedIds.has(question._id)}
            handleBookmarkClick={handleBookmarkClick}
            handleQuestionClick={handleQuestionClick}
          />
        ))}
      </div>
    </div>
  );
}

export default ExamPaperTableView;
